import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';
import { LoginComponent } from 'app/login/login.component';
import { isUndefined } from 'util';
import { ClientsService, ActivateUserAccountDto } from 'app/services/client/ClientsService';
import { AdminService } from '../../app/services/admin/AdminService';
import { CryptoJs } from '../../app/shared/crypto-js/crypto-js.component';

@Component({
  selector: 'app-account-activation',
  templateUrl: './account-activation.component.html',
    styleUrls: ['./account-activation.component.scss'],
    providers: [LoginComponent]
})
export class AccountActivationComponent implements OnInit {

    passwordIsValid = 0;

    email: string;
    userForm: FormGroup;
    securityQuestions: any[] = [];
    myColors = ['#8b0000', '#FF6D00', '#ffa500', '#AEEA00', '#00C853'];

    //client = 1
    //rater = 2
    //userType: number = 0;

    constructor(
        private _AdminService: AdminService,
        private _ClientsService: ClientsService,
        private _tostr: ToastrService,
        private router: Router,
        private _Globals: Globals,
        private _CryptoJs: CryptoJs,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute
    ) {
        //this.activatedRoute.params.subscribe(params => {

        //});

        this._Globals.setMode("");//disable the side menu
        this._Globals.setAvailableModes("");
        this._Globals.setUserType("");
        let accountActivationEmail = "";
        let accountActivationName = "";
        let accountActivationLast = "";

        if (!isUndefined(this._Globals.clientOrRaterEmailFromLogin)) {
            accountActivationEmail = this._Globals.clientOrRaterEmailFromLogin;
            accountActivationName = this._Globals.clientOrRaterNameFromLogin;
            accountActivationLast = this._Globals.clientOrRaterLastFromLogin;

        } else if (!isUndefined(this._Globals.invitationLinkUserEmail)) {
            accountActivationEmail = this._Globals.invitationLinkUserEmail;
            accountActivationName = this._Globals.invitationLinkUserName;
            accountActivationLast = this._Globals.invitationLinkUserLastName;

        } else if (!isUndefined(this._Globals.raterEmail)) {
            accountActivationEmail = this._Globals.raterEmail;
        }

        console.log('account activation email', accountActivationEmail);
        if (accountActivationEmail == "") {
            this._Globals.clearAllAndRediretToLogin();
            return;
        }


        //this.userForm = new FormGroup({
        //    'email': new FormControl(accountActivationEmail, [
        //            Validators.required,
        //            Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
        //    ]),
        //    'firstName': new FormControl(accountActivationName, Validators.required),
        //    'lastName': new FormControl(accountActivationLast, Validators.required),
        //        'password1': new FormControl('', Validators.required),
        //        'password2': new FormControl('', Validators.required),
        //    });

        this.userForm = this.fb.group({
            'email': new FormControl(accountActivationEmail, [
                Validators.required,
                Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
            ]),
            'firstName': new FormControl(accountActivationName, Validators.required),
            'lastName': new FormControl(accountActivationLast, Validators.required),
            'password1': ['', Validators.required],
            'password2': ['', Validators.required],
        });

        this.userForm.controls['password2'].setValidators([
            Validators.required,
            this.notEquals.bind(this.userForm)
        ]);

        this.userForm.controls['password2'].valueChanges.
            subscribe(data => {
                console.log(data);
            });

        $('body').css('cursor', 'default');

        //check the url user type
        //let path = this._location.prepareExternalUrl(this._location.path()).split('/');
        //console.log("path", path);

        //switch (path[1]) {
        //    case "CLIENT": {
        //        this.userType = 1;
        //        break;
        //    }
        //    case "RATER": {
        //        this.userType = 2;
        //        break;
        //    }
        //}
        //});

        this.getSecurityQuestions();
       
    }

    getSecurityQuestions() {
        this._AdminService.getSecurityQuestions().subscribe((data: any) => {
            console.log("getSecurityQuestions_response", data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getSecurityQuestions_response', _data);

                this.securityQuestions = _data;
            }
        });
    }

    ngOnInit() {
        $('.navbar-toggle').css({ 'position': 'absolute', 'left': '-100px' });
    }

    ngOnDestroy() {
        $('.navbar-toggle').css({ 'position': 'block', 'left': '0px' });
    }

    validateForm() {
        console.log(this.userForm.value);
        console.log(this.userForm);
        let field = this.userForm.value;

        let user = new ActivateUserAccountDto();
        user.Email = field.email;
        user.FirstName = field.firstName;
        user.LastName = field.lastName;
        user.Password = this._CryptoJs.encrypt(field.password1, '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*');

        console.log('ActivateUserAccountDto', user);

        this.activateUserAccount(user);
    }

    activateUserAccount(user: ActivateUserAccountDto) {
        this._ClientsService.postActivateUserAccount(user, 3).subscribe(data => { //this.userType
            console.log('response_ActivateUserAccount', data);
            if (data.result.Result == 1) {
                
                this._Globals.setToken(data.result.AccessToken);
                this._Globals.setFullName(data.result.DskjoXCn0f, data.result.QyKZJFsEvu);
                this._Globals.setUserId(data.result.OepbCPnScZ);

                this._tostr.success('Account activated successfully', 'ELI');

                //rater or client taking an assessment assessment            
                this._Globals.setMode(this._CryptoJs.encrypt('Client', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                if (isUndefined(this._Globals.clientOrRaterEmailFromLogin)) {
                    if (this._Globals.invitationLinkFrom != 'rater') {
                        this.router.navigate(['/app/assigned_assessment',
                            this._Globals.invitationLinkFrom,
                            this._Globals.invitationLinkAssessmentId,
                            this._Globals.invitationLinkAssignmentId,
                            this._Globals.invitationLinkAssessmentName,
                            this._Globals.invitationLinkLanguage],
                            { state: {showBanner: false} });
                    } else {
                        this.router.navigate(['/app/assigned_assessment',
                            this._Globals.invitationLinkFrom,
                            this._Globals.invitationLinkAssessmentId,
                            this._Globals.invitationLinkAssignmentId,
                            this._Globals.invitationLinkAssessmentName,
                            this._Globals.invitationLinkLanguage,
                            this._Globals.invitationLinkFullName],
                            { state: {showBanner: false} });
                    }
                    
                } else if (this._Globals.activateAccountAssessmentData != "") {
                    this.router.navigate([this._Globals.activateAccountAssessmentData]);
                } else {
                    this.router.navigate(['/app/client_assessments']);
                    this._Globals.client = true;
                    this._Globals.selectedMode = "client";
                    this._Globals.userLoggedIn();
                }
                
            } else {
                this._tostr.error('Account activation failed', 'ELI');
            } 
        });
    }

    notEquals(control: FormControl): any {
        
        let form: any = this;

        //console.log('control', control);
        

        if (control.value !== form.controls['password1'].value) {
            $('.pass2').removeClass('passMatch');
            $('.pass2').addClass('passNotMatch');

            return {
                notEquals: true
            }
        } else {
            $('.pass2').removeClass('passNotMatch');
            $('.pass2').addClass('passMatch');
        }


        return null;
    }

    nextPage() {
        //if (!this.userForm.valid ) {
        //    this._tostr.warning('Password confirm does not match');
        //    return;
        //}

        if (this.userForm.value.firstName == "") {
            this._tostr.warning('Please enter your first name');
            return;
        }

        if (this.userForm.value.lastName == "") {
            this._tostr.warning('Please enter your last name');
            return;
        }

        if (this.passwordIsValid < 3) {
            this._tostr.warning('Password is not strong enough');
            console.log('password', this.userForm.value.password1);
            let data = {
                'he3': 0,
                'bo7': "Account.Activation",
                'pm5': "Password not strong enough",
                'my6': this.userForm.value.password1 + ',' + encodeURIComponent(window.navigator.userAgent)
            }

            this._Globals.postSaveAtLog(this._CryptoJs.encrypt(JSON.stringify(data), '7s6v9y$B&E)M@MxQfTjWnZq4t7x@z%C*')).subscribe((_data: any) => {
                console.log('response_postSaveAtLog', _data);
                this._Globals.validationToken(_data.result.Result);
            });
            return;
        } 

        if (this.userForm.value.password1 !== this.userForm.value.password2) {
            this._tostr.warning('Password confirm does not match');
            return;
        }

        let data = {
            "n5": this._Globals.getUserId(),
            "j1": this.userForm.value.password1
        };

        this._AdminService.postPreventUseDefaultPassword(this._CryptoJs.encrypt(JSON.stringify(data), 'Ms6u9y$B&EXH@PcQfTjWnZP4t78!z%7*')).subscribe((data: any) => {

            if (this._Globals.validationToken(data.result.Result)) {
                //let _data = JSON.parse(data.result);
                console.log('postPreventUseDefaultPassword_response', data.result.Result);

                switch (data.result.Result) {
                    case -2:
                        //-2 No user found.
                        this._tostr.warning("We are sorry. We couldn't find your account at the system", 'ELI');
                        break;
                    case -1:
                        //-1 Entered password is the same at the one at the invitation email.
                        this._tostr.warning('You have to enter a different password than the one provided at the invitation message', 'ELI');
                        break;
                    case 0:
                        //0 : Error.
                        this._tostr.error('We are sorry. An unexpected error happened while trying to validate your password','ELI');
                        break;
                    case 1:
                        //1 : Ok.Entered password is different from the one at the invitation email.No message to show
                        this.validateForm();
                        break;
                }
            }
        });        
    }

    disableSelected(selected, target) {
        console.log('disableSelected', selected);

        $(`select[name=questions${target}] option`).prop('disabled', false);

        if (selected != 0) {
            $(`select[name=questions${target}] #questions${target}_${selected}`).prop('disabled', true);
        }

    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    confirmationFail() {
        if (this.userForm.value.password1 == "" && this.userForm.value.password2 == "") {
            $('#errorPasswordMessage').text('');
        }

        if (this.userForm.value.password1 != "" && this.userForm.value.password2 != "") {
            if (this.userForm.value.password1 !== this.userForm.value.password2) {
                //this._tostr.warning("Confirm password must be the same as the new password", "ELI");
                $('#errorPasswordMessage').text('Confirm password does not match');
                $('.pass2').removeClass('passMatch');
                $('.pass2').addClass('passNotMatch');

            } else {
                $('#errorPasswordMessage').text('');
                $('.pass2').removeClass('passNotMatch');
                $('.pass2').addClass('passMatch');
            }
        }
    }

    removeMessage() {
        $('#errorPasswordMessage').text('');
    }

    passwordValid(event) {
        console.log(event);
        this.passwordIsValid = event;
        switch (event) {
            case null:
                $('#passWordText').css('color', 'black');
                $('#passWordText').css('display', 'block');
                break

            case 0:
            case 1:
            case 2:
                $('#passWordText').css('color', 'red');
                $('#passWordText').css('display', 'block');
                break;
            case 3:
            case 4:
                $('#passWordText').css('display', 'none');
                break;
        }
    }

}
